import { createRoot } from "react-dom/client";
import { ThemeProvider } from "next-themes";
import App from "./App.tsx";
import "./index.css";

// After a new publish, old hashed files disappear. Any dynamic import outside the
// lazy pages (e.g. on-demand modules) then fails; reload once to pick up the new version.
const PRELOAD_RELOAD_KEY = "tk:preload-reload";
const isChunkError = (msg: string) =>
  msg.includes("Importing a module script failed") ||
  msg.includes("Failed to fetch dynamically imported module") ||
  msg.includes("error loading dynamically imported module");
const reloadOnce = () => {
  if (sessionStorage.getItem(PRELOAD_RELOAD_KEY)) return false;
  sessionStorage.setItem(PRELOAD_RELOAD_KEY, "1");
  window.location.reload();
  return true;
};
window.addEventListener("vite:preloadError", (event) => {
  if (reloadOnce()) event.preventDefault();
});
window.addEventListener("unhandledrejection", (event) => {
  const msg = String((event.reason as Error)?.message ?? event.reason ?? "");
  if (isChunkError(msg) && reloadOnce()) event.preventDefault();
});
setTimeout(() => sessionStorage.removeItem(PRELOAD_RELOAD_KEY), 10000);

createRoot(document.getElementById("root")!).render(
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
    <App />
  </ThemeProvider>
);
